import { IJustTextProperties } from '@vfde-brix/ws10/just-text';
import { JarvisProduct } from '../../interface';
import { getCMSConfig } from '../cms';
import { ProductType } from '../../enum';
import { formatDownload } from '../formatter';

/**
 * Gets the props that need to be
 * updated for the avc result justText
 */
export const getAvcJustTextProps = (
    alternativeTariff: JarvisProduct | undefined,
): Partial<IJustTextProperties> => {
    const config = getCMSConfig().avcResult;

    switch (alternativeTariff?.productType) {
        case ProductType.DSL:
            return { content: formatDownload(config.dsl.text, alternativeTariff.download) };
        case ProductType.FIBRE:
            return { content: formatDownload(config.fiber.text, alternativeTariff.download) };
        default:
            return { content: config.gigacube.text };
    }
};
